import React from 'react';
import PageLayout from '../components/layout/PageLayout';

const TurfsPage = () => {
  return (
    <PageLayout title="Turfs - PakPoints">
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <div className="mb-8">
              <div className="text-6xl mb-4">⚽</div>
              <h1 className="text-4xl font-bold text-gray-900 mb-4">Turfs</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Find and book sports turfs, football grounds, cricket pitches, and other sports facilities in your area.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-8 max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Football Turfs */}
                <div className="bg-green-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">⚽</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Football Turfs</h3>
                  <p className="text-gray-600 text-sm">Book football grounds and 5-a-side pitches</p>
                </div>

                {/* Cricket Grounds */}
                <div className="bg-blue-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">🏏</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Cricket Grounds</h3>
                  <p className="text-gray-600 text-sm">Find cricket pitches and nets for practice</p>
                </div>

                {/* Tennis Courts */}
                <div className="bg-yellow-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">🎾</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Tennis Courts</h3>
                  <p className="text-gray-600 text-sm">Book tennis courts for matches and practice</p>
                </div>

                {/* Basketball Courts */}
                <div className="bg-orange-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">🏀</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Basketball Courts</h3>
                  <p className="text-gray-600 text-sm">Find basketball courts and indoor facilities</p>
                </div>

                {/* Swimming Pools */}
                <div className="bg-cyan-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">🏊</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Swimming Pools</h3>
                  <p className="text-gray-600 text-sm">Book swimming pools and aquatic facilities</p>
                </div>

                {/* Multi-Purpose Halls */}
                <div className="bg-purple-50 rounded-lg p-6 text-center">
                  <div className="text-3xl mb-3">🏟️</div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Multi-Purpose Halls</h3>
                  <p className="text-gray-600 text-sm">Versatile sports halls for various activities</p>
                </div>
              </div>

              <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Coming Soon</h3>
                <p className="text-gray-600 mb-4">
                  We're developing a comprehensive platform to help you find and book sports facilities. 
                  This section will include real-time availability, online booking, pricing information, 
                  and reviews from other sports enthusiasts.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">Football Turfs</span>
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">Cricket Grounds</span>
                  <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-sm rounded-full">Tennis Courts</span>
                  <span className="px-3 py-1 bg-orange-100 text-orange-800 text-sm rounded-full">Basketball Courts</span>
                  <span className="px-3 py-1 bg-cyan-100 text-cyan-800 text-sm rounded-full">Swimming Pools</span>
                  <span className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full">Multi-Purpose Halls</span>
                </div>
              </div>

              <div className="mt-6 p-6 bg-blue-50 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Features Coming Soon</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Real-time availability checking
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Online booking and payment
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Price comparison and deals
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    User reviews and ratings
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Location-based search
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Mobile app integration
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default TurfsPage;
